import React from 'react';
import { View, Image, TouchableOpacity } from 'react-native';
import { Icon } from 'react-native-elements';
import Colors from '../../../constants/Colorsv2';
import Styles from '../../../constants/Styles';
import { Text } from '../../../globalComponents/NativeOverrides';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import { GroupProps } from '../../../store/types/soc_svc';

type GroupChatHeaderType = { 
    group:GroupProps
    players:PublicPlayerProps[]
    onClose:() => void
}
function GroupChatHeader ({ group, onClose, players }:GroupChatHeaderType) {


    return (
        <View style={{ flexDirection:'row', alignItems:'center', backgroundColor:Colors.brand.midnight }}>
            <View style={{flex:1/5, flexDirection:'row', alignItems:'center'}}>
                <TouchableOpacity style={{padding:17, paddingRight:0, flexDirection:'row', alignItems:'center'}} onPress={() => onClose()}> 
                    <View style={{ marginRight:12, height:25, justifyContent:'center', alignItems:'center' }}>
                        <Icon name='x' type='feather' size={16} color={Colors.shades.white} />
                    </View>
                </TouchableOpacity>
            </View>
            <View style={{ flex:3/5 }}>
                <Text size={16} color={Colors.shades.white} weight='bold' textAlign='center'>{group.name}</Text>
                <Text style={{ marginTop:3 }} size={14} color={Colors.shades.white} weight='regular' textAlign='center'>{group.description}</Text>
            </View>
            <View style={{ flex:1/5, justifyContent:'center', alignItems:'flex-end', paddingRight:10}}>
                {group.group_image ?
                    <Image style={{height:40, width:40, borderRadius:100}} source={group?.group_image?{ uri: group.group_image }:require('../../../assets/images/default-avatar.png')} />
                :
                <View style={{ height:40, width:40, borderRadius:100, backgroundColor:Colors.shades.white, justifyContent:'center', alignItems:'center' }}>
                    <Icon name='message-circle' size={24} color={Colors.brand.midnight} type='feather'/>
                </View>
                }
            </View>
        </View>
    )
}

export default GroupChatHeader